import React, {Component} from 'react'
import {Spin, Form, Row, Select, DatePicker, Col, Card, Button} from 'antd'
import Moment from 'moment'
import {connect} from 'react-redux'
import getDate from 'util/ConfigDates'
import {fetchCompanies, fetchDataCompanies} from 'appRedux/actions/Companies'
const Option = Select.Option
const FormItem = Form.Item

class ReportBalanceCompany extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateFrom: getDate('dateFrom'),
      dateTo: getDate('dateTo'),
      idCompany: 0,
      validateDate: 'error',
      helpDate: 'Este es un campo obligatorio.',
    }
  }

  componentDidMount() {
    this.props.fetchCompanies()
  }

  onHandleClick = event => {
    event.preventDefault()
    if (
      this.state.dateFrom !== '' &&
      this.state.dateTo !== '' &&
      this.state.idCompany !== 0
    ) {
      this.props.fetchDataCompanies(this.state)
    } else {
      this.setState({idCompany: ''})
    }
  }

  onClickDateFrom = (date, dateString) => {
    this.setState({
      dateFrom: dateString,
    })
  }

  onClickDateTo = (date, dateString) => {
    this.setState({dateTo: dateString})
  }

  arrayC = () => {
    let array = this.props.companies
    return array.map((element, index) => {
      return (
        <Option key={index} value={element.id}>
          {element.name}
        </Option>
      )
    })
  }

  handleChangeCombo = value => {
    this.setState({
      idCompany: value,
    })
  }

  render() {
    const {idCompany, dateFrom, dateTo, validateDate, helpDate} = this.state

    return (
      <Card>
        <Form onSubmit={this.onHandleClick}>
          <Row>
            <Col span={10}>
              <FormItem
                label="Desde :"
                validateStatus={dateFrom !== '' ? '' : validateDate}
                help={dateFrom !== '' ? '' : helpDate}
                labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
              >
                <DatePicker
                  defaultValue={Moment(dateFrom, 'YYYY-MM-DD')}
                  className="gx-mb-3 gx-w-100"
                  onChange={this.onClickDateFrom}
                />
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem
                label="Hasta : "
                validateStatus={dateTo !== '' ? '' : validateDate}
                help={dateTo !== '' ? '' : helpDate}
                labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
              >
                <DatePicker
                  defaultValue={Moment(dateTo, 'YYYY-MM-DD')}
                  className="gx-mb-3 gx-w-100"
                  onChange={this.onClickDateTo}
                />
              </FormItem>
            </Col>
            <Col span={4} className="gx-text-right">
              <Button type="primary" onClick={this.onHandleClick}>
                <i className="icon icon-search" />
              </Button>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem
                label="Compañia"
                labelCol={{xs: 12, sm: 8, lg: 8, md: 12}}
                validateStatus={idCompany !== '' ? '' : validateDate}
                help={idCompany !== '' ? '' : helpDate}
              >
                <Select
                  className="gx-mr-3 gx-mb-3"
                  defaultValue="Seleccionar"
                  onChange={this.handleChangeCombo}
                  style={{width: 140}}
                >
                  {this.arrayC()}
                </Select>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>
    )
  }
}

function mapStateToProps({reports, companiesInfo}) {
  const {companies} = companiesInfo

  return {
    companies,
  }
}

export default connect(
  mapStateToProps,
  {fetchDataCompanies, fetchCompanies},
)(ReportBalanceCompany)



// WEBPACK FOOTER //
// ./src/routes/main/Reports/balanceCompany/ReportBalanceCompany.js